/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import CaptchaPopup from '@/components/popup/captcha-popup.vue';
import { useUserStore } from '@/stores/modules/user';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    __name: 'advanced',
    props: {
        autocomplete: {
            type: Boolean,
            default: false
        },
        agreed: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'finished',
        'input-click'
    ],
    setup: function(__props, param) {
        var expose = param.expose, emit = param.emit;
        var props = __props;
        var form = reactive({
            phone: '',
            captcha: ''
        });
        var isValidPhone = computed(function() {
            return !/^\d{10}$/.test(form.phone);
        });
        var visibleMap = reactive({
            captcha: false
        });
        var formRef = ref();
        var captchaRef = ref(null);
        var userStore = useUserStore();
        var captchaLoading = ref(false);
        /**
 * 提交登录手机号
 */ var onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    if (!form.phone.length) {
                        Toast('Ingrese su número de teléfono.');
                        return [
                            2
                        ];
                    }
                    if (isValidPhone.value) {
                        Toast('ngrese el número de teléfono correcto.');
                        return [
                            2
                        ];
                    }
                    if (!props.agreed) {
                        Toast('Por favor, haga clic para aceptar el acuerdo.');
                        return [
                            2
                        ];
                    }
                    // 打开验证码弹窗
                    visibleMap.captcha = true;
                    return [
                        2
                    ];
                });
            });
            return function onSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
 * 获取验证码
 */ var fetchCaptcha = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                userStore.sendCaptcha({
                                    mobileNumber: form.phone
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCaptcha() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
 * 验证码输入完成后去登录
 */ var onCaptchaFinished = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(val) {
                var err, _captchaRef_value;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            form.captcha = val;
                            captchaLoading.value = true;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                userStore.login({
                                    mobileNumber: form.phone,
                                    loginRandomCode: form.captcha
                                })
                            ];
                        case 2:
                            _state.sent();
                            emit('finished');
                            closeCaptcha();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            (_captchaRef_value = captchaRef.value) === null || _captchaRef_value === void 0 ? void 0 : _captchaRef_value.clear();
                            captchaLoading.value = false;
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function onCaptchaFinished(val) {
                return _ref.apply(this, arguments);
            };
        }();
        /**
 * 关闭验证码窗口
 */ var closeCaptcha = function() {
            var _captchaRef_value;
            visibleMap.captcha = false;
            (_captchaRef_value = captchaRef.value) === null || _captchaRef_value === void 0 ? void 0 : _captchaRef_value.clear();
            captchaLoading.value = false;
        };
        expose({
            submit: function() {
                var _formRef_value;
                (_formRef_value = formRef.value) === null || _formRef_value === void 0 ? void 0 : _formRef_value.submit();
            }
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            form: form,
            isValidPhone: isValidPhone,
            visibleMap: visibleMap,
            formRef: formRef,
            captchaRef: captchaRef,
            userStore: userStore,
            captchaLoading: captchaLoading,
            onSubmit: onSubmit,
            fetchCaptcha: fetchCaptcha,
            onCaptchaFinished: onCaptchaFinished,
            closeCaptcha: closeCaptcha,
            CaptchaPopup: CaptchaPopup
        };
    }
});
